import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Boxes, Package, MapPin, Newspaper, FileText, Mail } from "lucide-react";
import { api } from "../../lib/api";

const cards = [
  { key: "brands", icon: Boxes, label: "Brands", path: "/admin/brands" },
  { key: "products", icon: Package, label: "Products", path: "/admin/products" },
  { key: "dealers", icon: MapPin, label: "Dealers", path: "/admin/dealers" },
  { key: "blog_posts", icon: Newspaper, label: "Blog Posts", path: "/admin/blog" },
  { key: "manuals", icon: FileText, label: "Manuals", path: "/admin/manuals" },
  { key: "submissions", icon: Mail, label: "Submissions", path: "/admin/submissions" },
];

export default function Dashboard() {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    const load = async () => {
      const [b, p, d, posts, m, s] = await Promise.all([
        api.get("/brands").then((r) => r.data),
        api.get("/products").then((r) => r.data),
        api.get("/dealers").then((r) => r.data),
        api.get("/blog").then((r) => r.data),
        api.get("/manuals").then((r) => r.data),
        api.get("/submissions").then((r) => r.data).catch(() => []),
      ]);
      setCounts({
        brands: b.length,
        products: p.length,
        dealers: d.length,
        blog_posts: posts.length,
        manuals: m.length,
        submissions: s.length,
      });
    };
    load();
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">Overview</div>
      <h1 className="font-display text-4xl tracking-tighter mb-10">Dashboard</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map((c) => (
          <Link
            key={c.key}
            to={c.path}
            className="border border-white/10 bg-[#0A0A0A] p-6 hover:border-white/30 transition-colors flex items-start justify-between"
            data-testid={`dashboard-card-${c.key}`}
          >
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">{c.label}</div>
              <div className="font-display text-4xl">{counts[c.key] ?? "—"}</div>
            </div>
            <c.icon size={24} className="text-zinc-600" />
          </Link>
        ))}
      </div>
    </div>
  );
}
